import styled from 'styled-components';
import { Grid, TextField } from '@mui/material';

export const VerificationGrid = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const StyledTextField = styled(TextField)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  & .MuiOutlinedInput-root {
    border-radius: 8px;
  }

  & .MuiInputLabel-root {
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  & .MuiFormHelperText-root {
    margin-left: 0;
  }
`;